export const CONSENT_ASKED_URL = {
  gaming: {
    local: "https://static-login-stg.nvidia.com/service/gfn/consent/",
    dev: "https://static-login-stg.nvidia.com/service/gfn/consent/",
    stage: "https://static-login-stg.nvidia.com/service/gfn/consent/",
    prod: "https://static-login.nvidia.com/service/gfn/consent/",
  },
  developer: {
    local: "https://static-login-stg.nvidia.com/service/default/consent/",
    dev: "https://static-login-stg.nvidia.com/service/default/consent/",
    stage: "https://static-login-stg.nvidia.com/service/default/consent/",
    prod: "https://static-login.nvidia.com/service/default/consent/",
  },
  enterprise: {
    local: "https://static-login-stg.nvidia.com/service/default/consent/",
    dev: "https://static-login-stg.nvidia.com/service/default/consent/",
    stage: "https://static-login-stg.nvidia.com/service/default/consent/",
    prod: "https://static-login.nvidia.com/service/default/consent/",
  },
};

export const VALIDATIONS = {
  urlRegex:
    /(^https?:\/\/[^\/]*\.nvidia\.(com|cn)(\/[A-Za-z0-9\-\._~:\/\?#\[\]@!$&'\(\)\*\+,;\=]*)?)/,
};
